import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Modal, Select, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import countryList from 'react-select-country-list';
import { cw, hp } from '../../utils';

import AuthHeader from './Header';
import axios from 'axios';

const SignIn = (props) => {
    const { signIn, intl, _utils, _auth: { signingIn } } = props;

    const [form] = Form.useForm();
    const [countryForm] = Form.useForm();

    const [countryModal, setCountryModal] = useState(false);
    const [countrying, setCountrying] = useState(false);

    const _signin = (vals) => {
        signIn(intl, _utils.lang, { email: vals.email.toLowerCase().trim(), password: vals.password }, (res) => {
            if (!res.user.country || res.user.country === 'undefined') {
                setCountryModal(true);
            } else {
                window.location.assign(hp.getSuccessRedirect());
            }
        });
    };

    const _setCountry = () => {
        countryForm.validateFields().then((v) => {
            const user = JSON.parse(hp.getCookie('user') || '{}');
            const account = JSON.parse(hp.getCookie('active_account') || '{}');
            setCountrying(true);
            axios({
                method: 'put',
                url: `${hp.getApiBaseUrl()}/accounts/${account.id}`,
                headers: { 'x-access-token': hp.getCookie('user_token') },
                data: v
            }).then((response) => {
                const res = response.data;
                if (res.statusCode === 200) {
                    axios({
                        method: 'put',
                        url: `${hp.getApiBaseUrl()}/users/${user.user_id}`,
                        headers: { 'x-access-token': hp.getCookie('user_token') },
                        data: v
                    }).then((response) => {
                        const res = response.data;
                        if (res.statusCode === 200) {
                            window.location.assign(hp.getSuccessRedirect());
                        } else {
                            setCountrying(false);
                            notification.error({ message: intl.formatMessage(cw['SetCountry.Failed']) });
                        }
                    }).catch(() => {
                        setCountrying(false);
                    });
                } else {
                    setCountrying(false);
                    notification.error({ message: intl.formatMessage(cw['SetCountry.Failed']) });
                }
            }).catch(() => {
                setCountrying(false);
                notification.error({ message: intl.formatMessage(cw['SetCountry.Failed']) });
            });
        }).catch(() => {});
    };

    return (
        <React.Fragment>
            <Form id="esoko__signin" form={form} layout="vertical" autoComplete="off" requiredMark={false} onFinish={_signin}>
                <AuthHeader screen="signin" />

                <Form.Item required={true} colon={false} name="email" label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}
                    rules={[{ required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> }]}
                >
                    <Input autoFocus autoComplete="off" size="large" placeholder="you@domain.com" sso-id="login-username" />
                </Form.Item>
                <Form.Item required={true} colon={false} name="password" label={<FormattedMessage id="Label.Password" defaultMessage="Password" />}
                    rules={[{ required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> }]}
                >
                    <Input.Password autoComplete="off" size="large" type="password" placeholder={intl.formatMessage(cw['Placeholder.Password'])} sso-id="login-password" />
                </Form.Item>
                <Form.Item noStyle shouldUpdate={(prev, cur) => prev.email !== cur.email || prev.password !== cur.password}>
                    {() => (
                        <Form.Item>
                            <Button className="submitBtn" block size="large" type="primary" htmlType="submit" disabled={!form.getFieldValue('email') && !form.getFieldValue('password')} loading={signingIn} sso-id="login-button">
                                <FormattedMessage id="auth_signin_button" defaultMessage="Sign in" />
                            </Button>
                        </Form.Item>
                    )}
                </Form.Item>

                <div className="formLinks">
                    <Link to={`/${_utils.lang || 'en'}/reset${window.location.search}`} className="auth_form_links_forgot" sso-id="reset-link">
                        <FormattedMessage id="auth_signin_forgot_link" defaultMessage="Forgot password?" />
                    </Link>
                    <p>
                        <span className="noAccountText"><FormattedMessage id="auth_signin_not_account" defaultMessage="Don't have an account?" /></span>
                        <Link to={`/${_utils.lang || 'en'}/signup${window.location.search}`} sso-id="signup-link"><FormattedMessage id="auth_signin_create_account_link" defaultMessage="Sign up" /></Link>
                    </p>
                </div>
            </Form>

            <Modal title={null} open={countryModal} centered footer={null}>
                <h4><FormattedMessage id="SetCountry.Title" defaultMessage="Choose a country" /></h4>
                <p><FormattedMessage id="SetCountry.Description" defaultMessage="We realised you did not choose a country upon signup, please choose one now." /></p>

                <Form id="esoko__setcountry" form={countryForm} layout="vertical" requiredMark={false} onFinish={_setCountry}>
                    <Form.Item colon={false} name="country" label={<FormattedMessage id="Label.Country" defaultMessage="Country" />}
                        rules={[{ required: true, message: <span /> }]}
                        initialValue="Ghana"
                    >
                        <Select size="large" showSearch={true} sso-id="signup-userCountry">
                            {(countryList().getData()).map(cnt => (
                                <Select.Option key={cnt.label} value={cnt.label}>{cnt.label}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Button className="submitBtn" size="large" type="primary" htmlType="submit" loading={countrying} sso-id="signup-button">
                        <FormattedMessage id="Button.Submit" defaultMessage="Submit" />
                    </Button>
                </Form>
            </Modal>
        </React.Fragment>
    );
};

export default SignIn;